// extracted by mini-css-extract-plugin
export default {"productGallery":"QI-z","inQuickShop":"RI-z"};